module.exports = __webpack_public_path__ + "img/igc.0f0a7c79.png";